import { __extends } from "tslib";
import { IgCollection } from "igniteui-react-core";
import { SyncableObservableCollection$2 } from "igniteui-react-core";
import { CalloutPlacementPositions_$type } from './CalloutPlacementPositions';
import { ensureEnum } from "igniteui-react-core";
var IgrCalloutPlacementPositionsCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrCalloutPlacementPositionsCollection, _super);
    function IgrCalloutPlacementPositionsCollection(list) {
        var _this = _super.call(this) || this;
        if (list) {
            for (var i = 0; i < list.length; i++) {
                _this.add(list[i]);
            }
        }
        return _this;
    }
    IgrCalloutPlacementPositionsCollection.prototype._ensureOuter = function (item) {
        return ensureEnum(CalloutPlacementPositions_$type, item);
    };
    IgrCalloutPlacementPositionsCollection.prototype._createInnerColl = function () {
        var coll = new SyncableObservableCollection$2(CalloutPlacementPositions_$type, CalloutPlacementPositions_$type, 0);
        coll.compare = function (ext, int) {
            var comp = ext;
            if (comp.equals) {
                return comp.equals(int);
            }
            return comp === int;
        };
        coll.createTo = function (ext) {
            return ext;
        };
        coll.createFrom = function (int) {
            return int;
        };
        return coll;
    };
    return IgrCalloutPlacementPositionsCollection;
}(IgCollection));
export { IgrCalloutPlacementPositionsCollection };
